import { getData, postData, convertPageModel } from './api-base.service'

export const createWorkflowModel = () => {
  return {
    Id: 0,
    StudentId: 0,
    CourseId: 0,
    CourseName: "",
    CourseActivationId: null,
    Week: 0,
    Minutes: 0,
    ApplicationType: 0,
    ApplicationDescription: "",
    Price: 0,
    BalanceCost: 0,
    BonusPointCost: 0,
    BonusPointPrice: 0,
    Step: 0,
    IsCompleted: false,
    Status: 0,
    FileList: [],
    ScheduleList: []
  };
}

export const getVideoAppointmentList = (model) => {
  let data = convertPageModel(model);

  let result = postData(`/VideoAppointment/GetVideoAppointmentList`, data);
  return result;
}

export const getVideoAppointmentApplicationType = () => {
  let result = getData(`/VideoAppointment/GetVideoAppointmentApplicationType`);
  return result;
}

export const getVideoAppointmentPrice = () => {
  let result = getData(`/VideoAppointment/GetVideoAppointmentPrice`);
  return result;
}

export const getUniversityAllVideoPrice = (studentId) => {
  let data = {studentId: studentId};
  let result = getData(`/VideoAppointment/GetUniversityAllVideoPrice`, data);
  return result;
}

export const getVideoAppointmentDepositPrice = () => {
  let result = getData(`/VideoAppointment/GetVideoAppointmentDepositPrice`);
  return result;
}

export const getCourseWeekListPageData = (model) => {
  let data = convertPageModel(model);

  let result = postData('/VideoAppointment/GetCourseWeekListPageData', data);
  return result;
}

export const getVideoAppointment = (id) => {
  let data = { id: id };
  let result = getData('/VideoAppointment/GetVideoAppointment', data);
  return result;
}

export const operateVideoAppointment = (id, status, isRefund, reason) => {
  let data = { Id: id, Status: status, IsRefund: isRefund, Reason : reason};
  let result = postData('/VideoAppointment/OperateVideoAppointment', data);
  return result;
}

export const cancelVideoAppointment = (id) => {
  let data = { id: id };
  let result = getData('/VideoAppointment/CancelVideoAppointment', data);
  return result;
}

export const saveWorkflowData = (data) => {
  if (!!data.ScheduleList) {
    data.ScheduleList.forEach(element => {
      if (isNaN(element.Id)) {
        element.Id = 0;
      }
      if (isNaN(element.VideoAppointmentId)) {
        element.VideoAppointmentId = 0;
      }
    });
  }
  let result = postData('/VideoAppointment/SaveWorkflowData', data);
  return result;
}

export const getScheduleList = (studentId, date, campusId, appointmentId, isOneHour) => {
  let data = {StudentId: studentId, DateText: date, CampusId: campusId, AppointmentId: appointmentId, IsOneHour: isOneHour};
  let result = postData('/VideoAppointment/GetScheduleList', data);
  return result;
}

export const savePayment = (id, price, balanceCost, bonusPointCost, bonusPointPrice) => {
  let data = {
    Id: id,
    Price: price,
    BalanceCost: balanceCost,
    BonusPointCost:bonusPointCost,
    BonusPointPrice: bonusPointPrice
  }
  let result = postData('/VideoAppointment/SavePayment', data);
  return result;
}

export const getCheckAllVideoResult = (model) => {
  let data = convertPageModel(model);
  return getData('/VideoAppointment/GetCheckAllVideoResult',data);
}

export const checkAllVideoFiles = () => {
  return getData('/VideoAppointment/CheckAllVideoFiles');
}

export const updateWatchApproved = (id, code, reason) => {
  let data = { Id: id, Code: code, Reason: reason };
  let result = postData('/VideoAppointment/UpdateWatchApproved', data);
  return result;
}

export const getPendingVideoAppointmentCount = () => {
  return getData('/VideoAppointment/GetPendingVideoAppointmentCount');
}

export const getPendingVideoAppointmentCountWithCampus = () => {
  return getData('/VideoAppointment/GetPendingVideoAppointmentCountWithCampus');
}

export const getConfirmWatchData = (id) => {
  let data = { id: id };
  return getData('/VideoAppointment/GetConfirmWatchData', data);
}

export const saveSproutVideoResult = (sproutVideo, fileName, size, courseActivationId, fileId) => {
  let data = { 
    SproutVideo: sproutVideo,
    FileName: fileName,
    Size: size,
    CourseActivationId: courseActivationId,
    FileId: fileId
  };
  let result = postData('/VideoAppointment/SaveSproutVideoResult', data);
  return result;
}

export const getSproutVideoFile = (id) => {
  let data = { id };
  return getData('/VideoAppointment/GetSproutVideoFile', data);
}

export const getSproutVideoPath = (id) => {
  let data = { id };
  return getData('/VideoAppointment/GetSproutVideoPath', data);
}

export const getSproutVideoPathByCA = (courseActivationId) => {
  let data = { courseActivationId: courseActivationId };
  return getData('/VideoAppointment/GetSproutVideoPathByCA', data);
}

export const getSproutVideoUploadToken = () => {
  return getData('/VideoAppointment/GetSproutVideoUploadToken');
}


export const getSproutVideoUploadSetting = (courseActivationId) => {
  let data = {
    courseActivationId: courseActivationId
  };
  return getData('/VideoAppointment/GetSproutVideoUploadSetting', data);
}


export const getSproutVideoUploadSettingNonCA = (type, courseId, title) => {
  let data = {
    type,
    courseId,
    title
  };
  return getData('/VideoAppointment/GetSproutVideoUploadSettingNonCA', data);
}



// WEBPACK FOOTER //
// ./src/service/videoAppointment.service.js